import { render, staticRenderFns } from "./distributed.vue?vue&type=template&id=3bfa4727&scoped=true&"
import script from "./distributed.vue?vue&type=script&lang=js&"
export * from "./distributed.vue?vue&type=script&lang=js&"
import style0 from "./distributed.vue?vue&type=style&index=0&id=3bfa4727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa4727",
  null
  
)

export default component.exports